import request from '@/utils/request';

export function downloadOrderPickList(productionPlanningID, workshopID, serialNumbers) {
  return request({
    method: 'get',
    url: `orderpicklist/${productionPlanningID}`,
    params: {
      workshopID: workshopID,
      serialNumbers: serialNumbers
    },
    responseType: 'blob'
  });
}

export function downloadSentOrderPickList(orderPicklistID) {
  return request({
    method: 'get',
    url: `orderpicklist/downloadsentorderpicklist`,
    params: {
      orderPicklistID: orderPicklistID
    },
    responseType: 'blob'
  });
}

export function getOrderPickListItems(orderPicklistID) {
  return request({
    method: 'get',
    url: `orderpicklist/GetOrderPickListItems`,
    params: {
      orderPicklistID: orderPicklistID
    }
  });
}
export function getOrderPickListFabricSuggestions(orderPicklistID) {
  return request({
    method: 'get',
    url: `orderpicklist/GetOrderPickListFabricSuggestions`,
    params: {
      orderPicklistID: orderPicklistID
    }
  });
}

function updateOrderPickList(dto) {
  return request({
    data: dto,
    method: 'put',
    url: '/orderpicklist'
  });
}

function addFabricToOrderPickList(fabricID, orderPickListID) {
  return request({
    data: { fabricID, orderPickListID },
    method: 'post',
    url: 'orderpicklist/AddFabricToOrderPickList'
  });
}

export const storeExtensions = {
  actions: {
    downloadOrderPickList({ dispatch }, { productionPlanningID, workshopID, serialNumbers }) {
      return new Promise((resolve, reject) =>
        downloadOrderPickList(productionPlanningID, workshopID, serialNumbers)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    downloadSentOrderPickList({ dispatch }, { orderPicklistID }) {
      return new Promise((resolve, reject) =>
        downloadSentOrderPickList(orderPicklistID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getOrderPickListItems({ dispatch }, { orderPickListID }) {
      return new Promise((resolve, reject) =>
        getOrderPickListItems(orderPickListID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    updateOrderPickList({ commit }, dto) {
      return updateOrderPickList(dto);
    },
    getOrderPickListFabricSuggestions({ dispatch }, { orderPickListID }) {
      return new Promise((resolve, reject) =>
        getOrderPickListFabricSuggestions(orderPickListID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    addFabricToOrderPickList({ dispatch }, { fabricID, orderPickListID }) {
      return addFabricToOrderPickList(fabricID, orderPickListID);
    }
  }
};
